import { styled, StyledComponentProps } from '@mui/material/styles';
import { FC, ReactNode } from 'react';

const AppBarControlsRoot = styled('div', {
  name: 'O2AppBar',
  slot: 'Controls',
})(() => ({
  display: 'flex',
  alignSelf: 'stretch',
}));

export interface AppBarControlsProps extends StyledComponentProps {
  children?: ReactNode;
}

const AppBarControls: FC<AppBarControlsProps> = ({ children, ...other }) => {
  return <AppBarControlsRoot {...other}>{children}</AppBarControlsRoot>;
};

export default AppBarControls;
